<template>
  <div>
    <div class="title">노선별 주간 연비 추이 (km)</div>
    <bar-chart v-if="week.length" :chart-data="chartdata" :options="options"></bar-chart>
  </div>
</template>

<script>
import { getDayOfGroupList } from '@/api'
import barChart from '@/components/charts/bar-chart'
import get from 'lodash/get'
export default {
  components: {
    barChart
  },
  data () {
    return {
      week: [],
      chartdata: {
        labels: [6, 5, 4, 3, 2, 1, 0].map(val => this.$moment().add(-val, 'day').format('YY-MM-DD')),
        datasets: []
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  computed: {
    groups () {
      const groups = this.week.reduce((groups, days, index) => {
        days.forEach(day => {
          const groupId = get(day, '_gr._id', null)
          const fuelType = get(day, 'fuelType', 0)

          if (!groups[groupId + '|' + fuelType]) {
            groups[groupId + '|' + fuelType] = {
              label: get(day, '_gr.name', '미지정') + `(${({ 0: '미지정', 1: '경유', 2: 'CNG' })[fuelType]})`,
              // label: get(day, '_gr.name', '미지정'),
              data: [0, 0, 0, 0, 0, 0, 0]
            }
          }

          const fuel = get(day, 'dFuel', 0)
          const trip = get(day, 'dTrip', 0)
          groups[groupId + '|' + fuelType].data[index] = ((trip / fuel) || 0).toFixed(2)
        })

        return groups
      }, {})

      return groups
    }
  },
  created () {
    this.fetchTodayDayOfGroups()
  },
  watch: {
    groups (val) {
      this.chartdata.datasets = Object.values(val)
    }
  },
  methods: {
    async getDayOfGroups (moment) {
      try {
        const filters = {
          date: moment.format('YYYY-MM-DD')
        }

        const query = {
          populate: '_gr'
        }

        const { dayOfGroups } = await getDayOfGroupList(filters, query)
        return dayOfGroups
      } catch (err) {
        return []
      }
    },
    fetchTodayDayOfGroups () {
      const $promises = [6, 5, 4, 3, 2, 1, 0].map(val => {
        return this.getDayOfGroups(this.$moment().add(-val, 'day'))
      })

      Promise.all($promises).then((results) => {
        this.week = results
      })
    }
  }
}
</script>
